/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { HeadWrapper } from '../../elements';
import { setFlag } from '../../redux/flags/flags';
import FooterContainer from '../../components/FooterContainer/FooterContainer';
import './CookiePolicy.scss';

const mapDispatchToProps = {
  setFlag,
};

const CookiePolicy = (props) => {
  const { setFlag } = props;
  useEffect(() => {
    setFlag('isHeaderTermsLegals', true);
    return () => {
      setFlag('isHeaderTermsLegals', false);
    };
  }, [setFlag]);

  const handleCookies = () => {
    window.cookiehub.openSettings();
  };

  return (
    <>
      <HeadWrapper
        href="https://developer.staq.io/cookie-policy"
      />
      <div className="cookie">
        <div className="cookie__figure-left-center"></div>
        <div className="cookie__figure-top-right"></div>
        <div className="cookie__figure-bottom-right"></div>
        <div className="cookie__content">
          <h1>Cookie Policy</h1>
          <div className="cookie__box">
            <p>
              Our website and digital channels use cookies to distinguish you from other users. This
              helps us to provide you with a good experience when you browse our website and allows
              us to improve our site. For further information on how we use, store and keep your
              personal data secure, see our Privacy Policy.
            </p>
            <p>
              A cookie is a small file of letters and numbers that we store on your browser or the
              hard drive of your computer if you agree. Cookies contain information that is
              transferred to your computer's hard drive.
            </p>
            <p>We use the following cookies:</p>
            <ul>
              <li>
                <strong>Strictly necessary cookies</strong>. These are cookies that are required for
                the operation of our website. They include, for example, cookies that enable you to
                log into secure areas of our website, or make use of e-billing services.
              </li>
              <li>
                <strong>Analytical or performance cookies</strong>. These allow us to recognise and
                count the number of visitors and to see how visitors move around our website when
                they are using it. This helps us to improve the way our website works, for example,
                by ensuring that users are finding what they are looking for easily.
              </li>
              <li>
                <strong>Functionality cookies</strong>. These are used to recognise you when you
                return to our website. This enables us to personalise our content for you, greet you
                by name and remember your preferences (for example, your choice of language or
                region).
              </li>
              <li>
                <strong>Targeting cookies</strong>. These cookies record your visit to our website,
                the pages you have visited and the links you have followed. We will use this
                information to make our website and the advertising displayed on it more relevant to
                your interests. We may also share this information with third parties for this
                purpose.
              </li>
              <li>
                You can find more information about the individual cookies we use and the purposes
                for which we use them in the table below:
              </li>
            </ul>
          </div>
          <div className="cookie__table">
            <div className="cookie__table_title">
              <p>Cookie Name</p>
              <p>Purpose</p>
              <p>More information</p>
            </div>
            <div className="cookie__table_box">
              <div className="cookie__row">
                <div className="cookie__col">
                  <span className="cookie__label">Cookie Name</span>
                  <p>
                    <strong>Strictly Necessary Cookies</strong>
                  </p>
                </div>
                <div className="cookie__col">
                  <span className="cookie__label">Purpose</span>
                  <p>To make the website operational</p>
                </div>
                <div className="cookie__col">
                  <span className="cookie__label">Lawful basis for processing</span>
                  <p>
                    These cookies are necessary for the website to function and cannot be switched
                    off in our systems. They are usually only set in response to actions made by you
                    which amount to a request for services, such as setting your cookie preferences,
                    logging in or filling in forms. You can set your browser to block or alert you
                    about these cookies, but some parts of the site will not then work. These
                    cookies do not store any personally identifiable information.
                  </p>
                </div>
              </div>
              <div className="cookie__row">
                <div className="cookie__col">
                  <span className="cookie__label">Cookie Name</span>
                  <p>
                    <strong>Analytical or performance cookies</strong>
                    <br />
                    “_ga”{' '}
                  </p>
                </div>
                <div className="cookie__col">
                  <span className="cookie__label">Purpose</span>
                  <p>To get the website usage statistics</p>
                </div>
                <div className="cookie__col">
                  <span className="cookie__label">More information</span>
                  <p>
                    These cookies allow us to count visits and traffic sources so we can measure and
                    improve the performance of our site. They help us to know which pages are the
                    most and least popular and see how visitors move around the site. All
                    information these cookies collect is aggregated and therefore anonymous. 
                  </p>
                </div>
              </div>
              <div className="cookie__row">
                <div className="cookie__col">
                  <span className="cookie__label">Cookie Name</span>
                  <p>
                    <strong>Functionality cookies</strong>
                  </p>
                  <p>“OptanonConsent”,</p>
                  <p>“OptanonAlertBoxClosed”,</p>
                  <p>“optimizelyEndUserId”,</p>
                  <p> “ajs_anonymous_id”</p>
                </div>
                <div className="cookie__col">
                  <span className="cookie__label">Purpose</span>
                  <p>
                    These type of cookies are set by the 3rd party apps we may use to extend the
                    functionality of our website
                  </p>
                </div>
                <div className="cookie__col">
                  <span className="cookie__label">More information</span>
                  <p>
                    These cookies enable the website to provide enhanced functionality and
                    personalisation. They may be set by us or by third party providers whose
                    services we have added to our pages.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="cookie__box">
            <p>
              Please note that third parties may also use cookies, over which we have no control.
              These third parties may include, for example, advertising networks and providers of
              external services like web traffic analysis services. These third-party cookies are
              likely to be analytical cookies or performance cookies or targeting cookies
            </p>
            <p>
              To deactivate the use of third-party advertising cookies, you may visit the consumer
              page to manage the use of these types of cookies{' '}
              <a
                style={{ color: 'gray', cursor: 'pointer' }}
                onClick={handleCookies}
                target="blank"
              >
                Manage cookie
              </a>
              .
            </p>
            <p>
              You can block cookies by activating the setting on your browser that allows you to
              refuse the setting of all or some cookies. However, if you use your browser settings
              to block all cookies (including essential cookies) you may not be able to access all
              or parts of our website.
            </p>
          </div>
        </div>
      </div>

      <FooterContainer />
    </>
  );
};

export default connect(null, mapDispatchToProps)(CookiePolicy);
